import React from 'react';
import classNames from 'classnames';
import { object } from 'prop-types';
import TabContent from '../TabContent';
import CheckoutFormHOC from '../../shared/CheckoutFormHOC';
import { BASIC_PACKAGE_ID } from '../../../utils/packagesUtils/constants';

import './style.scss';

const singleClasses = classNames('packages-tabs', 'single');

// eslint-disable-next-line no-empty-pattern
const SinglePackage = ({}, { general }) => {
    const { isLimitedEdition } = general;
    const tabContentProps = {
        id: BASIC_PACKAGE_ID,
        showCompareAnchor: false
    };

    return (
        <div className={singleClasses}>
            {isLimitedEdition ?
                <TabContent {...tabContentProps}/> :
                <CheckoutFormHOC selectedPackageId={BASIC_PACKAGE_ID}
                    source="Top Right">
                    <TabContent {...tabContentProps}/>
                </CheckoutFormHOC>
            }
        </div>
    );
};

SinglePackage.contextTypes = {
    general: object
};

export default SinglePackage;
